/* global window, alert */
import { React, PT, fetchApi, withRouter } from '@gasbuddy/react';
import { Segment, Form, Header, Message, Divider, Label } from 'semantic-ui-react';

class BaseAccountTools extends React.Component {
  state = {
    planOfferingId: 365,
  }

  getResetLink = async (e) => {
    e.preventDefault();
    const { email } = this.props;
    const { body } = await fetchApi({
      url: '/devtools/account/links',
      body: { email },
    });
    window.open(body.reset, '_blank');
  }

  createBank = async (e, iav) => {
    e.preventDefault();
    const { accountId, history } = this.props;
    const { status, body, error } = await fetchApi({
      url: '/devtools/instrument/create/bank',
      body: {
        account_id: accountId,
        features: iav ? ['iav', 'verify-bank'] : [],
      },
    });
    if (status === 201) {
      history.push(`/payments/instrument-map/${body.instrument_account_map_id}`);
    } else {
      this.setState({ error: error || body });
    }
  }

  createWex = async (e) => {
    e.preventDefault();
    const { accountId, history } = this.props;
    const { status, body, error } = await fetchApi({
      url: '/devtools/instrument/create/wex',
      body: {
        account_id: accountId,
      },
    });
    if (status === 201) {
      history.push(`/payments/instrument-map/${body.instrument_account_map_id}`);
    } else {
      this.setState({ error: error || body });
    }
  }

  createAds = async (e) => {
    e.preventDefault();
    const { accountId, history } = this.props;
    const { status, body, error } = await fetchApi({
      url: '/devtools/instrument/create/ads',
      body: {
        account_id: accountId,
      },
    });
    if (status === 201) {
      history.push(`/payments/instrument-map/${body.instrument_account_map_id}`);
    } else {
      this.setState({ error: error || body });
    }
  }

  createFleetServ = async (e) => {
    e.preventDefault();
    const { accountId, history, firstName, lastName } = this.props;
    const { status, body, error } = await fetchApi({
      url: '/devtools/instrument/create/fleetcor',
      body: {
        account_id: accountId,
        first_name: firstName,
        last_name: lastName,
      },
    });
    if (status === 201) {
      history.push(`/payments/instrument-map/${body.instrument_account_map_id}`);
    } else {
      this.setState({ error: error || body });
    }
  }

  enrollInMembership = async (e) => {
    e.preventDefault();
    const { planOfferingId } = this.state;
    const { accountId } = this.props;
    const { body, error, status } = await fetchApi({
      url: '/devtools/membership/enroll',
      body: {
        account_id: accountId,
        plan_offering_id: planOfferingId,
      },
    });
    if (!error && [201, 200].includes(status)) {
      window.location.reload();
    } else {
      this.setState({ error: error || body });
    }
  }

  createGasBackTransaction = async (e) => {
    e.preventDefault();
    const { history, accountId } = this.props;
    const { status, body, error } = await fetchApi({
      url: '/devtools/account/gasback/create',
      body: {
        account_id: accountId,
      },
    });
    if (status === 200) {
      history.push(`/payments/transaction/${body.transaction.transaction_id}`);
    } else {
      this.setState({ error: error || body });
    }
  }

  async addClo(e, scheme) {
    e.preventDefault();
    const { accountId } = this.props;
    const { body, error } = await fetchApi({
      url: '/devtools/account/clo/add-card',
      body: {
        account_id: accountId,
        scheme,
      },
    });
    if (!error) {
      if (scheme === 'Visa:empyr') {
        // eslint-disable-next-line no-alert
        alert(`Card number is ${body.cardNumber}`);
      }
      window.location.reload();
    } else {
      this.setState({ error: error || body });
    }
  }

  async scheduleDeletion(e) {
    e.preventDefault();
    const { accountId } = this.props;
    const { status, body, error } = await fetchApi({
      url: '/devtools/account/deletion/schedule',
      body: {
        account_id: accountId,
      },
    });
    if (status === 201) {
      window.location.reload();
    } else {
      this.setState({ error: error || body });
    }
  }

  async generateStatement(e, backDateDays) {
    e.preventDefault();
    const { accountId, history } = this.props;
    const { status, body, error } = fetchApi({
      url: '/devtools/account/statement',
      body: {
        account_id: accountId,
        back_date_days: backDateDays,
      },
    });
    if (status === 200) {
      history.push(`/payments/transaction/${accountId}/${body.transaction_id}`);
    } else {
      this.setState({ error: error || body });
    }
  }

  render() {
    const { error, planOfferingId } = this.state;
    return (
      <div style={{ marginTop: 15 }}>
        <Header as="h3" block attached="top">
          Dev Tools
        </Header>
        <Segment attached>
          <Form horizontal error={!!error}>
            {error
              && (
              <Message error>
                Unable to complete request:
                <pre>{JSON.stringify(error, null, '\t')}</pre>
              </Message>
              )
            }

            <Form.Group inline>
              <Form.Button onClick={e => this.getResetLink(e, true)}>Open Password Reset</Form.Button>
            </Form.Group>

            <Form.Group inline>
              <Form.Button onClick={e => this.createBank(e, true)}>Create Bank w/IAV</Form.Button>
              <Form.Button onClick={e => this.createBank(e, false)}>Create Bank w/MD</Form.Button>
            </Form.Group>
            <Divider />
            <Form.Group inline>
              <Form.Button onClick={this.createWex}>Create Wex</Form.Button>
              <Form.Button onClick={this.createAds}>Create ADS</Form.Button>
              <Form.Button onClick={this.createFleetServ}>Create Fleetcor</Form.Button>
            </Form.Group>
            <Divider />
            <Form.Button onClick={this.createGasBackTransaction}>Create GasBack Affiliate Transaction</Form.Button>
            <Divider />
            <Form.Group inline>
              <Form.Button onClick={e => this.addClo(e, 'VISA')}>Enroll Visa in CLO</Form.Button>
              <Form.Button onClick={e => this.addClo(e, 'MasterCard')}>Enroll MC in CLO</Form.Button>
              <Form.Button onClick={e => this.addClo(e, 'Amex')}>Enroll Amex in CLO</Form.Button>
              <Form.Button onClick={e => this.addClo(e, 'Visa:empyr')}>Enroll Empyr-Only Visa in CLO</Form.Button>
            </Form.Group>
            <Divider />
            <Form.Group inline>
              <Form.Dropdown
                upward
                label="Enroll in membership"
                defaultValue={planOfferingId}
                options={[
                  { text: 'premium (monthly)', value: 332 },
                  { text: 'premium (yearly)', value: 1 },
                  { text: 'plus (monthly)', value: 365 },
                  { text: 'plus (yearly)', value: 364 },
                ]}
                onChange={(e, { value }) => this.setState({ planOfferingId: value })}
              />
              <Form.Button onClick={this.enrollInMembership}>Enroll</Form.Button>
              <Label pointing="left">Account should have a Bank Instrument</Label>
            </Form.Group>
            <Divider />
            <Form.Group inline>
              <Form.Button onClick={e => this.generateStatement(e, 1)}>Generate and Backdate Statement 1 Day</Form.Button>
              <Form.Button onClick={e => this.generateStatement(e, 7)}>Generate and Backdate Statement 7 days</Form.Button>
              <Form.Button onClick={e => this.generateStatement(e, 30)}>Generate and Backdate Statement 30 days</Form.Button>
              <Form.Button onClick={e => this.generateStatement(e, 35)}>Generate and Backdate Statement 35 days</Form.Button>
              <Form.Button onClick={e => this.generateStatement(e, 0)}>Generate Statement</Form.Button>
              <Form.Button onClick={e => this.scheduleDeletion(e)}>Schedule Account For Deletion</Form.Button>
            </Form.Group>
          </Form>
        </Segment>
      </div>
    );
  }
}

BaseAccountTools.propTypes = {
  accountId: PT.string,
  email: PT.string,
  firstName: PT.string,
  lastName: PT.string,
  history: PT.shape({
    push: PT.func,
  }).isRequired,
};

BaseAccountTools.defaultProps = {
  accountId: null,
  email: null,
  firstName: null,
  lastName: null,
};

export const AccountTools = withRouter(BaseAccountTools);
